import { AtsJobInput } from '../types';

// The limit in AppSync is 1 MB, but we are subtracting 1000 bytes to be on the safe side
const MAX_PAYLOAD_SIZE = 1048576 - 1000;

const splitCandidateBatchesRequestIntoChucks = (
  jobs: AtsJobInput[]
): AtsJobInput[][] => {
  const atsJobInputChunks: AtsJobInput[][] = [];
  let currentChunk: AtsJobInput[] = [];
  let currentChunkSize = 0;

  for (const job of jobs) {
    const jobSize = new TextEncoder().encode(JSON.stringify(job)).length;

    // Check if adding this job to the current chunk would exceed the payload size
    if (currentChunkSize + jobSize > MAX_PAYLOAD_SIZE) {
      // Add the current chunk to the list of chunks and start a new chunk
      atsJobInputChunks.push(currentChunk);
      currentChunk = [];
      currentChunkSize = 0;
    }

    // Add the job to the current chunk
    currentChunk.push(job);
    currentChunkSize += jobSize;
  }

  // Add the last chunk if it has any jobs
  if (currentChunk.length > 0) {
    atsJobInputChunks.push(currentChunk);
  }

  return atsJobInputChunks;
};

export { splitCandidateBatchesRequestIntoChucks };
